import styled from '@emotion/styled';
import {flatten} from '../../theme/helpers';

// Percentage of the viewport height for the radial gradient
const GRADIENT_HEIGHT = '40%';

export const Background = styled.div`
  position: relative;
  background-color: ${({theme}) => theme.color.surface.background};

  &::before {
    content: '';
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: ${GRADIENT_HEIGHT};
    background: radial-gradient(
      70% 90% at bottom,
      ${({theme}) => flatten(theme.color.primary, 0.2)} 0%,
      ${({theme}) => theme.color.surface.background} 90%
    );
  }
`;

export const Children = styled.div`
  position: relative;
  z-index: 1;
`;
